<div class="container">
    <div class="container-flights-calendar" *ngIf="calendar$ | async as calendarState">
        <div class="toolbar-container">
            <div class="toolbar">
                <div class="title">
                    <div class="pi pi-sync sync-icon" (click)="onRefreshClicked()"></div>
                    <div class="lastupdate-text">Updated:
                      <div *ngIf="lastUpdated else skeleton">
                        {{lastUpdated}}
                      </div>
                    </div>
                    <ng-template #skeleton>
                      <p-skeleton width="30px" height="17px"></p-skeleton>
                    </ng-template>
                  </div>
                  <div class="icon-container">
                    <i class="pi pi-question-circle help-icon" (click)="onHelpClicked()"></i>
                  </div>
            </div>
        </div>
        <div> 
            <full-calendar #calendar [options]="calendarOptions"
                [events]="calendarState.response?.events"></full-calendar>
        </div>
        <div class="holiday-pay" *ngIf="isHolidayPayMonth">
            <div class="color-box"></div>
            <div class="legend-label">Holiday Pay</div>
        </div>
    </div>
</div>